import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#027AFF",
      d: "M12 2.75a9.75 9.75 0 1 0 9.75 9.75A9.77 9.77 0 0 0 12 2.75m4.64 8.044-5.493 5.25a.76.76 0 0 1-.525.206.72.72 0 0 1-.516-.206L7.36 13.419a.75.75 0 1 1 1.032-1.088l2.23 2.128 4.988-4.753a.75.75 0 0 1 1.032 1.088"
    }, null, -1)
  ])))
}
export default { render: render }